import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tree-root mx-6 flex flex-col" }
const _hoisted_2 = { class: "tree-controls flex justify-end space-x-3 py-4 pr-4 border-b border-gray-300" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow text-xl" }, "Patient Clinical Details", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeRoot = _resolveComponent("TreeRoot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandAll && _ctx.expandAll(...args))),
        class: "expand-all text-sm cursor-pointer text-blue-500"
      }, " Expand All "),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.collapseAll && _ctx.collapseAll(...args))),
        class: "collapse-all text-sm cursor-pointer text-blue-500"
      }, " Collapse All ")
    ]),
    _createVNode(_component_TreeRoot, {
      ref: "tree",
      class: "flex-grow overflow-scroll",
      value: _ctx.details
    }, null, 8, ["value"])
  ]))
}